export interface IChartData {
  x: number;
  y: number;
  failureCodes?: string;
  marker?: { enabled: boolean; fillColor?: string; symbol?: string };
  additionalTooltip?: Array<{ label: string; value: string }>;
}

export enum TimeInMs {
  Month = 2592000000,
  Day = 86400000,
  TwelveHours = 43200000,
  Hour = 3600000,
  HalfHour = 1800000,
  QuarterHour = 900000,
  Minute = 60000,
  Second = 1000
}

export const HighChartSeriesColors = [
  '#2A4EC9', // OCEAN_BLUE
  '#27A0FF', // DODGER_BLUE
  '#87C93C', // ATLANTIS
  '#73726C', // TAPA
  '#1C9AC0', // LAKE
  '#D538C2', // CEREISE
  '#772AC9', // VIOLET
  '#C7C83E', // EARLY_GREEN
  '#13B0AB', // AQUA
  '#9900CF', // ELECTRIC_VIOLET
  '#3371B2', // SINGLE_LINE
  '#C92A8A', // FAIRY
  '#3BC4CA', // TOPASEE
  '#A0A52D', // TEA_OLIVE
  '#CA883B'  // DIJON
];

export enum HighchartsColorCodes {
  OCEAN_BLUE = '#2A4EC9',
  DODGER_BLUE = '#27A0FF',
  ATLANTIS = '#87C93C',
  TAPA = '#73726C',
  LAKE = '#1C9AC0',
  CEREISE = '#D538C2',
  VIOLET = '#772AC9',
  EARLY_GREEN = '#C7C83E',
  AQUA = '#13B0AB',
  ELECTRIC_VIOLET = '#9900CF',
  SINGLE_LINE = '#3371B2',
  FAIRY = '#C92A8A',
  TOPASEE = '#3BC4CA',
  TEA_OLIVE = '#A0A52D',
  DIJON = '#CA883B',
  DARKER_GRAY = '#8692a2',
  BAD = '#d50032',
  BLACK = '#000'
}

export enum HighchartsSeverity {
  CRITICAL = '#d50032',
  MAJOR = '#e65e0c',
  MINOR = '#f08b24',
  WARNING = '#ffb300',
  FAIR = '#c7c83e',
  GOOD = '#87c93c',
  BETTER = '#27a0ff',
  BEST = '#2a4ec9',
  OK = '#2da0a5'
}

export interface InitialData {
  chart: { color: string; field: string; name: string };
  data: { x: number; y: number; marker?: { enabled: boolean } }[];
}
